<template>
  <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-3">
    <button
      type="button"
      class="tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-px-3 tw-py-2 tw-text-sm tw-text-slate-700 hover:tw-bg-white disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
      @click="$emit('previousPage')"
      :disabled="disabled || page <= 0"
    >
      Prev
    </button>

    <div class="tw-flex tw-items-center tw-gap-1">
      <template v-for="item in paginationItems" :key="String(item)">
        <span v-if="item === 'ellipsis'" class="tw-px-2 tw-text-sm tw-text-slate-500">…</span>
        <button
          v-else
          type="button"
          class="tw-rounded-lg tw-border tw-px-3 tw-py-2 tw-text-sm tw-transition disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
          :class="item === page
            ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
            : 'tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-text-slate-700 hover:tw-bg-white'"
          @click="$emit('goToPage', item)"
          :disabled="disabled || item === page"
        >
          {{ item + 1 }}
        </button>
      </template>
    </div>

    <button
      type="button"
      class="tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-px-3 tw-py-2 tw-text-sm tw-text-slate-700 hover:tw-bg-white disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
      @click="$emit('nextPage')"
      :disabled="disabled || page + 1 >= totalPages"
    >
      Next
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PaginationBar',
  props: {
    page: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['previousPage', 'nextPage', 'goToPage'],
  computed: {
    paginationItems(): Array<number | 'ellipsis'> {
      const current = (this as any).page as number;
      const totalPages = (this as any).totalPages as number;

      const delta = 2;
      const last = Math.max(0, totalPages - 1);
      const start = Math.max(0, current - delta);
      const end = Math.min(last, current + delta);

      if (totalPages <= 1) return [0];

      const items: Array<number | 'ellipsis'> = [];
      items.push(0);

      if (start > 1) items.push('ellipsis');

      for (let p = start; p <= end; p += 1) {
        if (p === 0) continue;
        if (p === last) continue;
        items.push(p);
      }

      if (end < last - 1) items.push('ellipsis');
      items.push(last);

      return items
        .filter((val, idx, arr) => idx === 0 || val !== arr[idx - 1])
        .filter((val, idx, arr) => idx === 0 || val !== 'ellipsis' || arr[idx - 1] !== 'ellipsis');
    },
  },
});
</script>
